import { useEffect, useRef, useState } from "react";
import CountUp from "./CountUp";
import navneetLogo from "../../images/Navneet-Logo-Footer.png";
// The "!!file-loader!" prefix bypasses CRA's configured loaders for these
// imports, so the SVGs are emitted as plain files and returned as URLs instead
// of being compiled into React components by SVGR. Needed because these Canva
// exports contain XML namespace tags (c2pa:) that React's JSX cannot represent.
// They are only used as <img src>, so a URL is all we need.
import campaign1 from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/campaign1.svg";
import growingWall from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/growingWall.svg";
import growingWallMobile from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/growingWallMobile.svg";
import navdishaBanner from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/NavdishaBanner.svg";
import indianTelevison from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/indianTelevision.svg";
import impact from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/impact.svg";
import media from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/mediaNews.svg";
import open from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/open.svg";
import socialSamosa from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/socialSamosa.svg";
import delhi1 from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/Delhi 1.svg";
import mumbai from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/Mumbai.svg";
import karnatka from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/Karnatalkla.svg";
import navdishaBannerNew from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/navdishaBannernew.svg";
import nelDarkBgLogo from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/nelWhiteBorder.svg";
import directorate from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/directorate.svg";
import heros from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/herosTr.svg";
import saluteTr from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/saveAsTr.svg";
import award from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/award23.svg";
import lions from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/lions23.svg";
import shows from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/show23.svg";
import corporate from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/corporate23.svg";
import kitOnBanner from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/kitOnBanner.svg";
import vinitaImg from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/vinitaImg.svg";
import saveTr from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/Promotion/saluteTr.svg";
import trCard from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/cardImag1.svg";
import trCard2 from "!!file-loader?name=static/media/[name].[contenthash:8].[ext]!../../images/cardImg2.svg";
import { useBreakpoint } from "./useMediaQuery";
import { teacherApi, getUserData } from "./teacherApi";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import EastIcon from '@mui/icons-material/East';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import "./Promotion.css";
import Grid from '@mui/material/Grid2';


// Static slides for now — swap in real images/data later
const CAROUSEL_SLIDES = [
  { id: 1, image: navdishaBanner, alt: "Tr. for Teacher" },
  { id: 2, image: navdishaBannerNew, alt: "Tr. for Teacher" },
];

const NAV_LINKS = [
  { label: "The Initiative", target: "initiative" },
  { label: "Wall of Tr.s", target: "wall" },
  { label: "Films", target: "films" },
  { label: "Recognition", target: "recognition" },
];

const PRESS_ITEMS = [
  {
    id: 1,
    name: "Indian Televison",
    image: indianTelevison,
    url: "https://indiantelevision.com/mam/navneet-education-launches-teachers-day-campaign-save-as-tr/",
  },
  {
    id: 2,
    name: "Impact",
    image: impact,
    url: "https://www.impactonnet.com/more-from-impact/navneet-education-launches-teachers-day-film-urging-people-to-use-tr-for-educators-16449.html",
  },
  {
    id: 3,
    name: "Media News4u",
    image: media,
    url: "https://www.medianews4u.com/navneet-points-to-vacancies-in-profession-reiterates-tr-for-teacher-pledge/",
  },
  {
    id: 4,
    name: "Open The Magazine",
    image: open,
    url: "https://openthemagazine.com/branding-marketing-and-advertising/thank-you-sir-maam-why-the-teacher-remains-advertisings-favourite-memory",
  },
  { id: 5, name: "Social Samosa", image: socialSamosa, url: "https://www.socialsamosa.com/topical-spot/brands-look-beyond-classrooms-teachers-day-2026-campaigns-12493346" },
];
 const STATE_ORDER = ["delhi", "mumbai", "karnatka"];
const Promotion = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isActive, setIsActive] = useState(false)
  const [statename, setStateName] = useState("delhi")
  const [termsOpen, setTermsOpen] = useState(false)
  const [claimForm, setClaimForm] = useState({
    fullName: "",
    schoolName: "",
    phone: "",
    email: "",
    address: "",
  })

  const [agreeTerms, setAgreeTerms] = useState(false)
  const [downloading, setDownloading] = useState(false)
  const [claimFeedback, setClaimFeedback] = useState(null)
  const [stateTimerReset, setStateTimerReset] = useState(0);

  useEffect(() => {
  const SCRIPT_ID = "ga4-promotion-script";
  if (document.getElementById(SCRIPT_ID)) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", "G-V981Y2B3G8");
  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=G-V981Y2B3G8`;

  document.head.appendChild(script);
}, []);
  const handleClaimChange =
    (field) =>
    (e) => {
      let value = e.target.value;
      // Phone: allow digits only, max 10
      if (field === "phone") {
        value = value.replace(/\D/g, "").slice(0, 10);
      }
      setClaimForm((prev) => ({ ...prev, [field]: value }));
    };

  // Generate the Tr. kit: validate, then send the details to the backend.
  const handleGenerateKit = async () => {
    setClaimFeedback(null);

    if (!claimForm.fullName || !claimForm.schoolName) {
      setClaimFeedback({ type: "error", text: "Please enter at least your full name and school name." });
      return;
    }
    if (claimForm.phone && claimForm.phone.length !== 10) {
      setClaimFeedback({ type: "error", text: "Please enter a valid 10-digit phone number." });
      return;
    }

    setDownloading(true);
    try {
      // Capture the Front and Back cards exactly as shown, then put both into a single PDF.
      await document.fonts.ready;
      await new Promise((resolve) => setTimeout(resolve, 300));

      const [{ default: html2canvas }, { jsPDF }] = await Promise.all([
        import("html2canvas"),
        import("jspdf"),
      ]);

      const captureCanvas = async (elementId) => {
        const element = document.getElementById(elementId);
        if (!element) return null;
        return html2canvas(element, {
          scale: 3,
          useCORS: true,
          allowTaint: true,
          backgroundColor: null,
          logging: false,
        });
      };

      const frontCanvas = await captureCanvas("tr-card-front");
      const backCanvas = await captureCanvas("tr-card-back");

      if (frontCanvas && backCanvas) {
        // Each card becomes its own PDF page, sized to that card's aspect ratio.
        const pdf = new jsPDF({ orientation: "landscape", unit: "px", format: [frontCanvas.width, frontCanvas.height] });
        pdf.addImage(frontCanvas.toDataURL("image/jpeg", 1.0), "JPEG", 0, 0, frontCanvas.width, frontCanvas.height);

        pdf.addPage([backCanvas.width, backCanvas.height], "landscape");
        pdf.addImage(backCanvas.toDataURL("image/jpeg", 1.0), "JPEG", 0, 0, backCanvas.width, backCanvas.height);

        pdf.save(`Tr_${claimForm.fullName || "Teacher"}_Card.pdf`);
      }

      // Log/track on the backend
      const user = getUserData();
      await teacherApi.downloadVisitingCard({
        user_id: user?.fldi_id || 0,
        fullName: claimForm.fullName,
        email: claimForm.email,
        contact: claimForm.phone,
        isRegistered: user?.fldi_id ? "1" : "0",
        schoolName: claimForm.schoolName,
        address: claimForm.address,
      });

      setClaimFeedback({ type: "success", text: "Your Tr. kit has been generated successfully." });
      // Clear the form on success
      setClaimForm({ fullName: "", schoolName: "", phone: "", email: "", address: "" });
      setAgreeTerms(false);
    } catch (error) {
      const message = error instanceof Error ? error.message : "Unable to generate your Tr. kit. Please try again.";
      setClaimFeedback({ type: "error", text: message });
    } finally {
      setDownloading(false);
    }
  };
    const { isMobile, isTablet, isDesktop } = useBreakpoint();
    const showHamburger = isMobile || isTablet;

  // Auto-advance every 5s
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % CAROUSEL_SLIDES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
 
  useEffect(() => {
    const timer = setInterval(() => {
      setStateName((prev) => {
        const nextIndex = (STATE_ORDER.indexOf(prev) + 1) % STATE_ORDER.length;
        return STATE_ORDER[nextIndex];
      });
    }, 10000);
    return () => clearInterval(timer);
  }, [stateTimerReset]);

  const handleClick =(value)=>{
    setStateName(value);
    setStateTimerReset((prev) => prev + 1);
  }

  // Section refs for smooth-scrolling from the header nav
  const initiativeRef = useRef(null);
  const wallRef = useRef(null);
  const filmsRef = useRef(null);
  const recognitionRef = useRef(null);
  const pressRef = useRef(null);
  const termsRef = useRef(null);
  const claimFormRef = useRef(null);
  const fullNameRef = useRef(null);

  const sectionRefs = {
    initiative: initiativeRef,
    wall: wallRef,
    films: filmsRef,
    recognition: recognitionRef,
    press: pressRef,
  };

  const scrollToSection = (target) => {
    sectionRefs[target]?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div className="promotion">
      <header className="promotion__header">
        <div className="promotion__header-inner">
          <a className="promotion__logo" href="#top">
            <img src={navneetLogo} alt="Navneet" />
          </a>

          <nav className="promotion__nav">
            {NAV_LINKS.map((link) => (
              <button
                key={link.target}
                type="button"
                className="promotion__nav-link"
                onClick={() => scrollToSection(link.target)}
              >
                {link.label}
              </button>
            ))}
          </nav>

          <button type="button" className="promotion__cta" onClick={() => scrollToSection("recognition")}>
            Free Tr. Kit
          </button>
        </div>
      </header>

      {/* Floating CTA — fixed to the right edge, scrolls to the claim section */}
      <button
        type="button"
        className="kitFab"
        onClick={() => scrollToSection("recognition")}
      >
        <span>Get Your Tr.Card Here</span>
        <EastIcon className="kitFab__arrow"/>
      </button>

      <div className="carousalSection">
        <div className="carousal">
          <div
            className="carousal__track"
            style={{ transform: `translateX(-${activeSlide * 100}%)` }}
          >
            {CAROUSEL_SLIDES.map((slide) => (
              <div className="carousal__slide" key={slide.id}>
                <img src={slide.image} alt={slide.alt} />
              </div>
            ))}
          </div>
          {/* Dot navigation */}
          <div className="carousal__dots">
            {CAROUSEL_SLIDES.map((slide, index) => (
              <button
                key={slide.id}
                type="button"
                className={
                  index === activeSlide
                    ? "carousal__dot carousal__dot--active"
                    : "carousal__dot"
                }
                aria-label={`Go to slide ${index + 1}`}
                aria-current={index === activeSlide}
                onClick={() => setActiveSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="countContainer">
        <div className="countdata">
            <div className="trForTeacherCount">
                <div className="numberCount"><CountUp end={100000} suffix="+" /></div>
                <div className="trForTeacherCountText">Teachers in India, proudly use Tr.</div>
            </div>
             <div className="trForTeacherCount">
                <div className="numberCount"><CountUp end={12100} suffix="+" /></div>
                <div className="trForTeacherCountText">Schools Reached</div>
            </div>
             <div className="trForTeacherCount">
                <div className="numberCount"><CountUp end={15} suffix="+" /></div>
                <div className="trForTeacherCountText">States Reached</div>
            </div>
              <div className="trForTeacherCount">
                <div className="numberCount"><CountUp end={16} suffix="+"/></div>
                <div className="trForTeacherCountText">Industry Awards & Honours</div>
            </div>
        </div>
        <div className="watchVideoBtnContainer">
            <div className="watchVideo" onClick={() => scrollToSection("films")}><span className="playIcon"><PlayArrowIcon/></span><span>Watch the video</span></div>
            <div className="claimTrBtn" onClick={() => scrollToSection("recognition")}><span>Claim Personalised Tr. Kit</span><span className="playIcon"><EastIcon/></span></div>
        </div>

      </div>
      <div className="trTeacherInitiative" ref={initiativeRef}>
        <div className="trTeacherInitiativeBtm">The Tr. for Teacher Initiative</div>
        <Grid container spacing={2}>
            <Grid size={!isMobile ? 6 : 12}>
                <p className="professionText">A title for the profession that makes</p>
                <p className="professionText">every other profession possible</p>
                <p className="trTeacherInitiativeText">It started with a simple question: Why shouldn't teachers have a title of their own?</p>
                <p className="trTeacherInitiativeText">In 2022, Navneet Education set out to change the way we recognise teachers. Teachers shape every profession. Yet, unlike many of the professions they help create, they had no title of their own. We asked people to support the idea of recognising teachers with a title of their own,  <strong className="tr">"Tr".</strong></p>
                <p className="trTeacherInitiativeText"><strong>Nearly 40,000 people signed the petition. Over 100 schools came forward in support</strong>. Nationwide a #TrForTeacher campaign was launched on Teachers’ Day, the same year, calling for teachers to be recognised with the title “Tr.” before their names.</p>
                <p className="trTeacherInitiativeText">And that conversation didn't stop there.Over the years, more teachers, schools, organisations, authorities and people across the country have joined in.</p>
                <p className="trTeacherInitiativeText"><strong>An initiative that started in 2022 has grown into a movement</strong> that continues to recognise teachers with the title <strong className="tr">“Tr.”</strong></p>
            </Grid>
            <Grid size={!isMobile ? 6 : 12}>
            <a
              href={"https://youtu.be/RKZgtHb7ZLc?si=90UisT_I8NaRIulm"}
              target="_blank"
              rel="noopener noreferrer"
              className="pressCard pressCard--link pressCardHeight"
            >
              <img src={campaign1} alt="" className="src" />
            </a>
            </Grid>
            <Grid size={12}>
                <div className="campbanner">
                    <p className="campbannerText">“When a student first wrote <br></br> ‘Tr. Meera Nair’ on the board, I didn’t correct it. I just smiled. After 18 years of teaching, those two letters made me feel seen”</p>
                    <p className="campbannerSubText">Tr. Meera Nair, Sacred Heart High School, Pune</p>
                </div>
            </Grid>
        </Grid>
      </div>
      <div className="supportAcrossCont">
        <Grid className="stateWiseSection" container size={12}>
            <Grid size={!isMobile ? 5 : 12}>
                <p className="nationWide">Nationwide Movement</p>
                <p className="supportFromtext">Support Across India</p>
                <div className="stateContainer">
                    <div onClick={()=>handleClick("delhi")} className={statename === "delhi" ? "colorStateContainer" :"stateValue"}>Delhi</div>
                    <div onClick={()=>handleClick("mumbai")} className={statename === "mumbai" ? "colorStateContainer" :"stateValue"}>Mumbai</div>
                    <div onClick={()=>handleClick("karnatka")} className={statename === "karnatka" ? "colorStateContainer" :"stateValue"}>Karnataka</div>
                </div>
                {
                    statename=="delhi"?  
                    <div className="supportText">
                        <p>The Directorate of Education, Delhi, extended its support to the Tr. for Teacher initiative. In the presence of the former Chief Minister of Delhi, Mr. Arvind Kejriwal and former Education Minister Ms. Atishi Marlena Singh, Tr. for Teacher Kits were presented to the winners of the Delhi State Teacher Awards 2023, recognising their contribution to education.</p>
                        <p>Teachers in Delhi have also begun using “Tr.” before their names on nameplates, visiting cards and professional platforms, bringing the idea of recognition into their everyday identities.</p>
                    </div> : statename=="mumbai"? 
                    <div className="supportText">
                        <p>In 2024, “Tr.” took another step forward.</p>
                        <p>The Maharashtra School Education Department formally endorsed the movement, making "Tr." an official prefix for teachers across the state, giving the title a formal place alongside the professional titles used by doctors and advocates. The move extended across government, aided and non-aided schools and private schools.</p>
                    </div> :  
                    <div className="supportText">
                        <p>The movement reached another milestone in Karnataka.</p>
                        <p>On Teachers’ Day, the Karnataka government issued an order allowing teachers to use “Tr.” before their names, recognising their contribution to the progress and educational upliftment of society. With around 4.5 lakh teachers in the state, the order marked another step towards giving the teaching profession a recognised identity.</p>
                    </div> 
                }
            </Grid>
            <Grid size={!isMobile ? 5 : 12}>
                <img
                  src={statename === "mumbai" ? mumbai : statename === "karnatka" ? karnatka : delhi1}
                  alt=""
                  className="supportImg"
                />
            </Grid>
        </Grid>
      </div>
      <div className="growingWallContainer" ref={wallRef}>
        <p className="proofPoint">The Proof Point</p>
        <p className="growingWall">A Growing Wall of Tr.</p>
        <p className="growingWallText">Every name on this wall belongs to a teacher who decided the title belongs to them. It’s on their nameplate now. Their visiting card. Their email signature. This is where the campaign lives, not just in the awards it has won, but in the teachers who have chosen to make “Tr.” part of their identity.</p>
        <p className="growingWallText" style={{marginTop:"10px"}}>Claim your own Tr. below and add your name to the wall.</p>
        <p className="growingWallCounts">1,00,000+</p>
        <p className="growingWallTexttwo">‘Tr. for Teacher’ kits delivered to real teachers across India, and counting.</p>
        <div className="growingWallImgWrap">
            <img src={!isMobile ? growingWall : growingWallMobile} alt="" className="growingWallImg" />
        </div>
      </div>
      <div className="watchTheCapmpaign" ref={filmsRef}>
        <p className="filmsEyebrow">The Films</p>
        <p className="filmsTitle">The Tr. story, told over the years.</p>
        <Grid container size={12} spacing={3} className="filmsGrid">
            <Grid size={!isMobile ? 6 : 12}>
              <a
              href={"https://youtu.be/zeQbvNqhFM8?si=nLKz_LVDlmOAiQHU"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={saluteTr} alt="" className="filmImg" />
              </a>
            </Grid>
            <Grid size={!isMobile ? 6 : 12}>
               <a
              href={"https://youtu.be/4lLZ5QIfRPQ?si=Uw1CrNL470KjmdVX"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={saveTr} alt="" className="filmImg" />
              </a>
            </Grid>
            <Grid size={!isMobile ? 6 : 12}>
              <a
              href={"https://youtu.be/SQEHIKykP60?si=J_dW8usqyaAzQmJJ"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={heros} alt="" className="filmImg" />
              </a>
            </Grid>
            <Grid size={!isMobile ? 6 : 12}>
               <a
              href={"https://youtu.be/K4Ljgn9spJo?si=Yx9yxxIcgo1GMWNS"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={directorate} alt="" className="filmImg" />
              </a>
            </Grid>
        </Grid>
      </div>
      <div className="industryNoticed">
        <p className="recognition">Recognition</p>
        <p className="industryText">The Industry Noticed Too</p>
        <p className="industryCompleteText">The idea of giving teachers a title of their own caught the attention of the creative and communications industry, earning recognition across some of the country’s leading award platforms.</p>
              <Grid className="lionImgContainer" container size={12} spacing={2}>
                  <Grid size={{ xs: 12, md: 3 }}>
                      <img src={lions} alt="" className="awardImg" />
                  </Grid>
                  <Grid size={{ xs: 12, md: 3 }}>
                      <img src={shows} alt="" className="awardImg" />
                  </Grid>
                  <Grid size={{ xs: 12, md: 3 }}>
                      <img src={award} alt="" className="awardImg" />
                  </Grid>
                  <Grid size={{ xs: 12, md: 3 }}>
                      <img src={corporate} alt="" className="awardImg" />
                  </Grid>
              </Grid>
          </div>
          <div className="industryNoticed industryNoticedVideo" ref={pressRef}>
              <p className="recognition">In the Press</p>
              <p className="industryText">600+ Articles have told the Story</p>
              <p className="industryCompleteText">The idea of giving teachers a title of their own has travelled beyond the campaign, with coverage across trade, business and mainstream media.</p>
              <Grid className="pressReleaseAlign" container size={12} spacing={2}>
                  {PRESS_ITEMS.map((item) => (
                      <Grid size={{ xs: 12, sm: 6, md: 4 }} key={item.id}>
                          {item.url ? (
                            <a
                              href={item.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="pressCard pressCard--link"
                            >
                              <img src={item.image} alt={item.name} className="pressCard__img" />
                              <p className="pressCard__name">{item.name}</p>
                            </a>
                          ) : (
                            <div className="pressCard">
                              <img src={item.image} alt={item.name} className="pressCard__img" />
                              <p className="pressCard__name">{item.name}</p>
                            </div>
                          )}
                      </Grid>
                  ))}
              </Grid>
          </div>

      {/* Claim your Tr. — form + nameplate preview */}
      <div className="claimSection" ref={recognitionRef}>
        <Grid container spacing={4}>
          {/* Left: form */}
          <Grid size={!isMobile ? 6 : 12}>
            <p className="claimEyebrow">Join the Movement</p>
            <p className="claimTitle">Dear Teacher,</p>
            <p className="claimTitle">This one's for you!</p>
            <p className="claimSubText">
              Fill in your details and create your <br/><strong className="tr">Tr. Visiting Card</strong>, ready to download, use wherever you want to show your title.
            </p>

            <form className="claimForm" id="promo-claim-form" ref={claimFormRef} onSubmit={(e) => e.preventDefault()}>
              <input ref={fullNameRef} className="claimInput" type="text" placeholder="Full Name" value={claimForm.fullName} onChange={handleClaimChange("fullName")} />
              <input className="claimInput" type="text" placeholder="School Name" value={claimForm.schoolName} onChange={handleClaimChange("schoolName")} />
              <input className="claimInput" type="tel" inputMode="numeric" placeholder="Phone Number" value={claimForm.phone} onChange={handleClaimChange("phone")} />
              <input className="claimInput" type="email" placeholder="Email Address" value={claimForm.email} onChange={handleClaimChange("email")} />
              <input className="claimInput" type="text" placeholder="School Address" value={claimForm.address} onChange={handleClaimChange("address")} />

              <label className="claimCheckbox">
                <input type="checkbox" checked={agreeTerms} onChange={(e) => setAgreeTerms(e.target.checked)} />
                <span>
                  I confirm that I am a teacher based in India, and I agree to the{" "}
                  <strong>Terms and Conditions.</strong> By submitting this form, you consent to Navneet Education Limited using your details to contact you regarding its products, services and initiatives.
                </span>
              </label>

              <button type="button" className="claimSubmit" onClick={handleGenerateKit} disabled={downloading}>
               {downloading ? "Downloading..." : "Download My Tr. Visiting Card"}
              </button>

              {claimFeedback && (
                <p className={claimFeedback.type === "error" ? "claimFeedback claimFeedback--error" : "claimFeedback claimFeedback--success"}>
                  {claimFeedback.text}
                </p>
              )}
            </form>

            {!isMobile &&
              <>
              <div className="claimTerms" id="promo-terms" ref={termsRef}>
              <button
                type="button"
                className="claimTermsTitle"
                onClick={() => setTermsOpen((prev) => !prev)}
                aria-expanded={termsOpen}
              >
                <span className={termsOpen ? "claimTermsArrow claimTermsArrow--open" : "claimTermsArrow"}>▾</span>
                Terms and Conditions
              </button>
              {termsOpen && (
                <div className="claimTermsBody">
                  <p>By submitting this form, the applicant agrees to the following terms and conditions:</p>
                  <ol>
                    <li>This offer is available exclusively to teachers residing in India.</li>
                    <li>Each teacher shall be entitled to receive only one digital kit.</li>
                    <li>The digital kit will be delivered to the email address provided by the applicant.</li>
                    <li>This offer is valid for a limited period only, at Navneet Education's discretion.</li>
                    <li>Information submitted by applicants may be used by Navneet Education for the purpose of sending marketing and promotional communication.</li>
                  </ol>
                  <p className="claimTermsNote">
                    Your Tr. nameplate is generated and downloaded to your device immediately.
                  </p>
                </div>
              )}
            </div>

            <div className="claimActions">
              <button type="button" className="claimOutlineBtn" onClick={() => scrollToSection("wall")}>See the wall of Tr.s</button>
              <button type="button" className="claimOutlineBtn">Nominate a Teacher</button>
            </div>
            </>
            }
          </Grid>

          {/* Right: nameplate preview (Front + Back) */}
          <Grid size={!isMobile ? 6 : 12}>
            <div className="namePreview">
              <p className="namePreviewLabel">Front</p>
              <div className="nameCard nameCard--front" id="tr-card-front">
                <div className="nameCardFrame">
                  <img src={trCard} alt="" aria-hidden="true" className="nameCardBg" />

                  {/* Sits above the artwork */}
                  <div className="nameCardContent">
                    <p className="nameCardName">Tr. {claimForm.fullName}</p>
                    <p className="nameCardLine">{claimForm.schoolName || "SVM, International School"}</p>
                    <p className="nameCardLine">{claimForm.phone || "Phone number"}</p>
                    <p className="nameCardLine">{claimForm.email || "Email"}</p>
                    {/* <img src={navneetLogo} alt="Navneet" className="nameCardLogo" /> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="namePreview">
              <p className="namePreviewLabel">Back</p>
              <div className="nameCard nameCard--back" id="tr-card-back">
                <div className="nameCardFrameBack">
                  {/* Same treatment as the front: decorative artwork as a real
                      <img> so html2canvas reproduces it in the PDF. */}
                  <img src={trCard2} alt="" aria-hidden="true" className="nameCardBg" />

                  <div className="nameCardContent nameCardContent--back">
                    <p className="nameCardNameBack">Tr. {claimForm.fullName}</p>
                    <p className="nameCardSchoolBack">{claimForm.schoolName || "SVM International School"}</p>
                    <p className="nameCardAddrBack">
                      {claimForm.address || "Navneet Education Limited Navneet Bhavan, Bhavani Shankar Road, Dadar (W). Mumbai – 400 028. India."}
                    </p>
                    <img src={navneetLogo} alt="Navneet" className="nameCardLogoBack" />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
          {isMobile &&
            <>
              <div className="claimTerms" id="promo-terms" ref={termsRef}>
                <button
                  type="button"
                  className="claimTermsTitle"
                  onClick={() => setTermsOpen((prev) => !prev)}
                  aria-expanded={termsOpen}
                >
                  <span className={termsOpen ? "claimTermsArrow claimTermsArrow--open" : "claimTermsArrow"}>▾</span>
                  Terms and Conditions
                </button>
                {termsOpen && (
                  <div className="claimTermsBody">
                    <p>By submitting this form, the applicant agrees to the following terms and conditions:</p>
                    <ol>
                      <li>This offer is available exclusively to teachers residing in India.</li>
                      <li>Each teacher shall be entitled to receive only one digital kit.</li>
                      <li>The digital kit will be delivered to the email address provided by the applicant.</li>
                      <li>This offer is valid for a limited period only, at Navneet Education's discretion.</li>
                      <li>Information submitted by applicants may be used by Navneet Education for the purpose of sending marketing and promotional communication.</li>
                    </ol>
                    <p className="claimTermsNote">
                      Your Tr. nameplate is generated and downloaded to your device immediately.
                    </p>
                  </div>
                )}
              </div>
              <div className="claimActions">
                <button type="button" className="claimOutlineBtn" onClick={() => scrollToSection("wall")}>See the wall of Tr.s</button>
                <button type="button" className="claimOutlineBtn">Nominate a Teacher</button>
              </div>
            </>
          }
        </Grid>
      </div>

      {/* Kit banner — headline + kit image, between the claim section and footer */}
      <div className="kitBanner">
        <div className="kitBanner__inner">
          <div className="kitBanner__text">
            <p className="kitBanner__line">It started with two letters.</p>
            <p className="kitBanner__line">Today, it stands for something much bigger.</p>
            <p className="kitBanner__lineSubtext">Tr. for Teacher. A movement to recognise the people who shape every profession</p>
          </div>
          <div className="kitBanner__media">
            <img src={vinitaImg} alt="Tr. for Teacher kit" className="kitBanner__img" />
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="promoFooter">
        <div className="promoFooter__inner">
          <img src={nelDarkBgLogo} alt="Navneet" className="promoFooter__logo" />

          {/* Row 1: brand blurb + link columns + CTA + social */}
          <Grid container spacing={4} className="promoFooter__top">
            <Grid size={{ xs: 12, md: 4 }}>
              <p className="promoFooter__trust">65+ Years of Educational Trust</p>
              <p className="promoFooter__desc">
                Navneet Education is a knowledge-driven company providing educational content and learning solutions across print and digital, alongside stationery, EdTech and AI solutions for learners, educators and institutions.
              </p>
            </Grid>

            <Grid size={{ xs: 6, md: 2 }}>
              <p className="promoFooter__heading">Explore</p>
              <ul className="promoFooter__links">
                <li>
                  <button type="button" onClick={() => scrollToSection("initiative")}>The Initiative</button>
                </li>
                <li>
                  <button type="button" onClick={() => scrollToSection("wall")}>Wall of Tr.s</button>
                </li>
                <li>
                  <button type="button" onClick={() => scrollToSection("films")}>Films</button>
                </li>
                <li>
                  <button type="button" onClick={() => scrollToSection("recognition")}>Recognitions</button>
                </li>
                <li>
                  <button type="button" onClick={() => scrollToSection("press")}>Press</button>
                </li>
              </ul>
            </Grid>

            <Grid size={{ xs: 6, md: 2 }}>
              <p className="promoFooter__heading">Links</p>
              <ul className="promoFooter__links promoFooter__links--underlined">
                <li>
                  <a href="https://navneet.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    href="#promo-terms"
                    onClick={(e) => {
                      e.preventDefault();
                      setTermsOpen(true);
                      termsRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                    }}
                  >
                    Terms &amp; Conditions
                  </a>
                </li>
                <li>
                  {/* Sends the user to the Tr. kit form above and focuses the
                      first field, so the form is ready to type into. */}
                  <a
                    href="#promo-claim-form"
                    onClick={(e) => {
                      e.preventDefault();
                      claimFormRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                      // Focus after the smooth scroll settles; preventScroll
                      // stops the browser re-jumping and fighting the animation.
                      window.setTimeout(() => {
                        fullNameRef.current?.focus({ preventScroll: true });
                      }, 600);
                    }}
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </Grid>

            <Grid size={{ xs: 6, md: 2 }}>
              <p className="promoFooter__heading">Take action</p>
              <button type="button" className="promoFooter__claimBtn" onClick={() => scrollToSection("recognition")}>
                Claim your Tr.
              </button>
            </Grid>

            <Grid size={{ xs: 6, md: 2 }}>
              <p className="promoFooter__heading">Connect With Us</p>
              <div className="promoFooter__social">
                <a href="https://www.facebook.com/Navneet.India/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FacebookIcon /></a>
                <a href="https://www.instagram.com/navneet.education/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><InstagramIcon /></a>
                <a href="https://www.youtube.com/@NavneetEducationLtd" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><YouTubeIcon /></a>
                <a href="https://twitter.com/navneet_edu" target="_blank" rel="noopener noreferrer" aria-label="X"><XIcon /></a>
                <a href="https://www.linkedin.com/company/navneet-education-ltd-/posts/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><LinkedInIcon /></a>
              </div>
            </Grid>
          </Grid>

          <div className="promoFooter__dottedDivider" />

          {/* Row 2: tagline + registered office + contact details */}
          <Grid container spacing={4} className="promoFooter__mid">
            <Grid size={{ xs: 12, md: 4 }}>
              <p className="promoFooter__hashtag">#TrForTeacher</p>
              <p className="promoFooter__taglineText">
                An initiative by Navneet Education. <strong>Our legacy in education now stands behind the teachers who make every classroom possible.</strong>
              </p>
            </Grid>

            <Grid size={{ xs: 12, md: 4 }}>
              <p className="promoFooter__heading">Registered Office</p>
              <address className="promoFooter__address">
                Navneet Education Limited<br />
                Navneet Bhavan, Bhavani Shankar Road,<br />
                Dadar (W). Mumbai &ndash; 400 028. India.
              </address>
            </Grid>

            <Grid size={{ xs: 12, md: 4 }}>
              <dl className="promoFooter__contact">
                <div className="promoFooter__contactRow">
                  <dt>Tel</dt>
                  <dd><a href="tel:+912266626565">+91 22 66626565/1800 266 6676</a></dd>
                </div>
                <div className="promoFooter__contactRow">
                  <dt>Fax</dt>
                  <dd>+91 22 66626470</dd>
                </div>
                <div className="promoFooter__contactRow">
                  <dt>Email</dt>
                  <dd><a href="mailto:inquiry@navneet.com">inquiry@navneet.com</a></dd>
                </div>
                <div className="promoFooter__contactRow">
                  <dt>CIN</dt>
                  <dd>L22200MH1984PLC034055</dd>
                </div>
              </dl>
            </Grid>
          </Grid>

          <div className="promoFooter__divider" />

          {/* Bottom bar */}
          <div className="promoFooter__bottom">
            <span>&copy; Navneet Education Limited</span>
            <span>Tr. for Teacher &middot; an initiative by Navneet Education</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Promotion;
